import React from 'react';
import { Box } from '@mui/material';
import { mosaicPaths } from './mosaicPaths';

interface DressCodeMosaicProps {
  colors: string[];
}

const DressCodeMosaic: React.FC<DressCodeMosaicProps> = ({ colors }) => {
  const getColor = (index: number) => {
    return colors[index % colors.length] || '#333333';
  };

  let colorIndex = 0;

  return (
    <Box 
      display="flex" 
      justifyContent="center" 
      alignItems="center"
      sx={{ 
        width: '100%',
      }}
    >
      <svg 
        width="100%" 
        height="100%" 
        viewBox="0 0 1512 1512" 
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="rotate(-90 606 606) translate(0, 15) scale(0.98)">
          {mosaicPaths.map((group) => (
            <g id={group.id} key={group.id} transform={group.transform || ''} style={{ strokeWidth: group.strokeWidth, stroke: '#000' }}>
              {group.paths.map((path, pIndex) => (
                <path
                  key={pIndex}
                  transform={path.transform || ''}
                  fill={getColor(colorIndex++)}
                  stroke="#000"
                  strokeWidth={group.strokeWidth}
                  d={path.d}
                />
              ))}
            </g>
          ))}
        </g>
      </svg>
    </Box>
  );
};

export default DressCodeMosaic;